import { render, staticRenderFns } from "./CalendarWebpartTest.vue?vue&type=template&id=496a83bf"
import script from "./CalendarWebpartTest.vue?vue&type=script&lang=js"
export * from "./CalendarWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports